/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { Department } from '../models/Department';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class DepartmentService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @returns Department Success
     * @throws ApiError
     */
    public getAllDepartments(): Observable<Array<Department>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/department/get-all-departments',
        });
    }

}
